/**
 * Islands of Loom — Handkerchief quick add in the side cart
 * assets/iol-hanky-upsell.js
 *
 * While the cart is below ₹1,999 and has no handkerchief yet, show a small
 * "Add a handkerchief" card under the items. Clicking the card opens the handkerchief page; the + Add button adds one.
 * The card disappears as soon as a handkerchief is in the cart.
 */
(function () {
  'use strict';

  /* ───────── Settings (edit here) ───────── */
  var PRODUCT_HANDLE = 'linen-handkerchief';        /* the handkerchief product */
  var PREFERRED_PACK = 'Pack of 1';                  /* which pack the button adds */
  var THRESHOLD      = 199900;                       /* show the card while the cart is below this (paise = ₹1,999) */
  var GIFT_VARIANT_IDS = ['46766439006405', '50874070106309']; /* free gifts don't count toward the total */
  var HEADING        = 'Add a handkerchief';
  /* ──────────────────────────────────────── */

  var product = null;      /* product json, loaded once */
  var variant = null;      /* the variant the button adds */
  var busy = false;
  var wantCard = false;    /* last decision from the cart contents */
  var timer = null;

  function money(paise) {
    return '₹' + Math.round(paise / 100).toLocaleString('en-IN');
  }

  /* ───── styles (one tag, added once) ───── */
  function addStyles() {
    if (document.getElementById('iol-hanky-upsell-css')) return;
    var s = document.createElement('style');
    s.id = 'iol-hanky-upsell-css';
    s.textContent =
      '#iol-hanky-upsell{cursor:pointer;display:flex;align-items:center;gap:12px;margin:4px 0 14px;padding:10px 12px;' +
      'background:#EAE0CA;border:1px solid rgba(34,60,31,.14);border-radius:0;font-family:"DM Sans",sans-serif;color:#223C1F}' +
      '#iol-hanky-upsell img{width:52px;height:52px;object-fit:cover;border-radius:0;flex:0 0 auto;background:#F4EAD9}' +
      '#iol-hanky-upsell .iol-hu-txt{flex:1 1 auto;min-width:0;line-height:1.3}' +
      '#iol-hanky-upsell .iol-hu-h{font-size:14px;font-weight:600}' +
      '#iol-hanky-upsell .iol-hu-s{font-size:12px;opacity:.7}' +
      '#iol-hanky-upsell .iol-hu-btn{flex:0 0 auto;border:0;cursor:pointer;background:#223C1F;color:#F4EAD9;' +
      'font:600 13px "DM Sans",sans-serif;padding:9px 14px;border-radius:0;white-space:nowrap}' +
      '#iol-hanky-upsell .iol-hu-btn[disabled]{opacity:.6;cursor:default}';
    document.head.appendChild(s);
  }

  /* ───── load the handkerchief product once ───── */
  function loadProduct() {
    if (product) return Promise.resolve();
    return fetch('/products/' + PRODUCT_HANDLE + '.js')
      .then(function (r) { return r.json(); })
      .then(function (p) {
        product = p;
        var avail = p.variants.filter(function (v) { return v.available; });
        variant = avail.filter(function (v) { return v.title === PREFERRED_PACK; })[0] || avail[0] || null;
      })
      .catch(function () { product = null; });
  }

  /* ───── decide: does this cart need the card? ───── */
  function decide(cart) {
    var total = 0, hasHanky = false;
    cart.items.forEach(function (it) {
      if (it.handle === PRODUCT_HANDLE) hasHanky = true;
      if (GIFT_VARIANT_IDS.indexOf(String(it.variant_id)) === -1) total += it.final_line_price;
    });
    return cart.items.length > 0 && !hasHanky && total < THRESHOLD;
  }

  /* ───── build / remove the card ───── */
  function cardEl() { return document.getElementById('iol-hanky-upsell'); }

  function render() {
    var existing = cardEl();
    var form = document.querySelector('.cart-drawer__wrapper sht-cart-drwr-frm');

    if (!wantCard || !variant || !form) {
      if (existing) existing.remove();
      return;
    }
    if (existing) return;

    var img = (variant.featured_image && variant.featured_image.src) || product.featured_image || '';
    var card = document.createElement('div');
    card.id = 'iol-hanky-upsell';
    card.setAttribute('role', 'link');
    card.tabIndex = 0;
    card.innerHTML =
      (img ? '<img alt="" src="' + img.replace(/"/g, '') + '">' : '') +
      '<div class="iol-hu-txt"><div class="iol-hu-h">' + HEADING + '</div>' +
      '<div class="iol-hu-s">' + product.title + ' · ' + variant.title + ' · ' + money(variant.price) + '</div></div>' +
      '<button type="button" class="iol-hu-btn">+ Add</button>';
    form.insertAdjacentElement('afterend', card);

    /* Clicking the card goes to the handkerchief page; the Add button only adds. */
    function go() { window.location.href = '/products/' + PRODUCT_HANDLE; }
    card.addEventListener('click', function (e) {
      if (e.target.closest('.iol-hu-btn')) return;
      go();
    });
    card.addEventListener('keydown', function (e) {
      if (e.target === card && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); go(); }
    });

    card.querySelector('.iol-hu-btn').addEventListener('click', function (e) {
      e.stopPropagation();
      if (busy) return;
      busy = true;
      var btn = e.currentTarget;
      btn.disabled = true;
      btn.textContent = 'Adding…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variant.id, quantity: 1 })
      })
        .then(function (r) { return r.json(); })
        .then(function (d) {
          if (d.status && d.status !== 200) throw new Error(d.description || 'rejected');
          if (typeof SHTHelper !== 'undefined' && typeof SHTHelper.forceUpdateCartStatus === 'function') {
            SHTHelper.forceUpdateCartStatus();
          }
          wantCard = false;
          render();
        })
        .catch(function () {
          btn.disabled = false;
          btn.textContent = '+ Add';
        })
        .then(function () { busy = false; refresh(); });
    });
  }

  /* ───── refresh from the live cart ───── */
  function refresh() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          wantCard = decide(cart);
          return wantCard ? loadProduct() : null;
        })
        .then(render)
        .catch(function () {});
    }, 250);
  }

  /* ───── triggers ───── */
  addStyles();

  var CART_WRITE = /\/cart\/(add|change|update|clear)(\.js)?/;
  var _fetch = window.fetch;
  window.fetch = function (url) {
    var out = _fetch.apply(this, arguments);
    if (typeof url === 'string' && CART_WRITE.test(url)) out.then(refresh, function () {});
    return out;
  };

  document.addEventListener('cart:update', refresh);

  /* the drawer re-renders its contents: put the card back when that happens */
  function watchDrawer() {
    var d = document.getElementById('shtCartDrawer');
    if (!d) return;
    new MutationObserver(function () {
      var missing = wantCard && variant && !cardEl();
      var stray   = !wantCard && cardEl();
      if (missing || stray) render();
    }).observe(d, { childList: true, subtree: true });
    d.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.js-header-cart-status-btn')) refresh();
    });
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.js-header-cart-status-btn')) refresh();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { watchDrawer(); refresh(); });
  } else {
    watchDrawer();
    refresh();
  }
})();